var _defs, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhoneGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 421 386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #72a747;\n        font-family: AcuminPro-Bold, 'Acumin Pro';\n        font-size: 16.64px;\n        font-weight: 700;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-522.46 1091.09) rotate(43.99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-513.74 1099.41) rotate(39.65)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-503.51 1107.8) rotate(35.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "U"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-491.61 1116.07) rotate(31.38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-482.57 1121.58) rotate(28.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-470.53 1127.95) rotate(24.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-459.15 1133.1) rotate(22.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-453.64 1135.41) rotate(20.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-442.14 1139.57) rotate(18.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-436.51 1141.44) rotate(16.28)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-425.32 1144.67) rotate(13.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-413.26 1147.58) rotate(10.85)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-399.33 1150.2) rotate(8.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "U"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-385.88 1152.09) rotate(5.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-369.64 1153.43) rotate(2.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-357.65 1153.89) rotate(.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-345.52 1153.83) rotate(-1.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-339.89 1153.68) rotate(-3.07)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-325.92 1152.85) rotate(-6.03)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-311.71 1151.25) rotate(-7.89)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-306.15 1150.51) rotate(-9.62)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-293.68 1148.32) rotate(-11.49)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-287.04 1146.99) rotate(-13.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B"))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-274.55 1143.99) rotate(-15.97)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-263.09 1140.68) rotate(-18.24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-251.93 1136.96) rotate(-20.75)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-240.11 1132.39) rotate(-23.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "J"))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-232.08 1128.99) rotate(-25.72)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-219.34 1122.73) rotate(-28.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, ","))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-213.74 1119.72) rotate(-29.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-208.56 1116.81) rotate(-31.68)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L"))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-198.55 1110.61) rotate(-35.03)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D"))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(-186.99 1102.41) rotate(-38.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.03,241.82l-29.45-29.45c-8.12-8.12-21.33-8.12-29.45,0l-13.39,13.39c-6.15,6.15-16.16,6.15-22.31,0l-58.03-58.08c-6.16-6.16-6.17-16.15,0-22.32,2.16-2.16,8.35-8.35,13.39-13.39,8.09-8.09,8.2-21.26,0-29.46l-29.45-29.36c-8.12-8.12-21.33-8.12-29.43-.02-6.06,6.01-8.01,7.95-10.73,10.64-29.28,29.28-29.28,76.93,0,106.22l91.95,92c29.35,29.35,76.86,29.36,106.22,0l10.71-10.71c8.12-8.12,8.12-21.33,0-29.45h0ZM286.75,222.18l29.45,29.45c2.71,2.71,2.71,7.11,0,9.82l-4.91,4.91-39.27-39.28,4.91-4.91c2.71-2.71,7.11-2.71,9.82,0h0ZM147.51,82.98l29.45,29.36c2.71,2.71,2.71,7.1,0,9.82l-4.91,4.91-39.25-39.25,4.89-4.84c2.71-2.71,7.11-2.71,9.83,0h0ZM218.92,272.17l-91.95-92c-22.66-22.66-23.9-58.23-3.83-82.38l39.14,39.14c-10.28,11.66-9.86,29.42,1.29,40.56l58.03,58.08h0c11.13,11.13,28.89,11.59,40.56,1.29l39.14,39.14c-24.07,20.04-59.56,18.98-82.38-3.83h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneGreen);
export default __webpack_public_path__ + "static/media/icon_phone_green.00ee08eec2a003d35da3df6dd6b96bb8.svg";
export { ForwardRef as ReactComponent };